import React from 'react'

import Widget from '../Widget'
import HorizontalBarChart from '../components/HorizontalBarChart'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'
import withFetch from '../../../infrastructure/withFetch'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/visits/get-by-source/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry }) => (
        <Widget status={status} data={data} retry={retry}>
            <HorizontalBarChart
                data={data.map(d => ({
                    x: d.utmMedium
                        ? `${d.utmSource} - ${d.utmMedium}`
                        : d.utmSource,
                    y: d.count
                }))}
            />
        </Widget>
    ),
)

const tooltip = (
    <div>
        <p>
            This graph displays the number of visitors (unique browsers) who
            visited your event page by engaging with a campaign that included
            source tracking. Source tracking in campaigns is normally used to
            group all of your campaigns so you can see, per entity promoting
            your event, which campaigns are resonating with your target audience
            and generating interest in your event.
        </p>
        <p>
            If a visitor clicked on an email newsletter link, clicked on a
            Facebook advert and clicked on a web site banner advert that all had
            campaign (with source) tracking embedded, they will be counted 3
            times.
        </p>
        <p>
            Note: Customers who have already purchased tickets to this event are
            included in this data.
        </p>
        <p>
            We have the ability to track campaigns from any digital source
            whether it be email, web or social media. To measure the success of
            your campaigns, contact Oztix to organise the links to start
            tracking your campaigns.
        </p>
    </div>
)

const GetBySourceWidget = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle
            title="Sources that contributed the most visitors"
            tooltip={tooltip}
        />
        <Box>
            <Chart eventId={eventId} startDate={startDate} endDate={endDate} />
        </Box>
    </div>
)

export default GetBySourceWidget
